import { makeAutoObservable } from 'mobx';
import { stores } from 'state/stores';

interface UserCell {
  type: 'user';
  username: string;
  name?: string;
  profilePic?: string;
}

interface HeaderCell {
  type: 'header';
  title: string;
}

interface LoadingCell {
  type: 'loading';
}

type SuggestedAthletesCell = UserCell | HeaderCell | LoadingCell;

export class SuggestedAthletesViewModel {
  private isLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  private isFirstMount = true;
  onMounted = async () => {
    if (!process.browser) return;

    if (this.isFirstMount) {
      this.isFirstMount = false;
      this.fetchRecommendedUsers();
    }
  };

  fetchRecommendedUsers = async () => {
    this.isLoading = true;
    try {
      await stores.recommendedUsers.fetch();
    } catch {
    } finally {
      this.isLoading = false;
    }
  };

  get cells(): SuggestedAthletesCell[] {
    if (this.isLoading) {
      return [{ type: 'loading' }];
    }

    // For now, we only show 5 users since UI is not ready for more
    const users: UserCell[] = stores.recommendedUsers.users.slice(0, 5).map(u => ({
      type: 'user',
      username: u.username,
      name: u.full_name,
      profilePic: u.profile_pic,
    }));

    return [{ type: 'header', title: 'Suggested Athletes' }, ...users];
  }
}
